import { ActivityLogStatus } from '@this+that/models';

export enum ActivityLogChangeKey {
  SUBJECT = 'subject',
  DESCRIPTION = 'description',
  PRIORITY = 'priority',
  DUE_AT = 'dueAt',
  RESOLVED_AT = 'resolvedAt',
  IS_SUGGESTION = 'isSuggestion',
  TTL = 'ttl',
  TASK_LABEL_IDS = 'taskLabelIds',
  PARTICIPANT_IDS = 'participantIds',
  COMMUNICATION_IDS = 'communicationIds',
  TASK_GROUP_ID = 'taskGroupId',
  UPDATED_AT = 'updatedAt',
  DELETED_AT = 'deletedAt',
  VERSION = 'version',
  RESOLUTION_SUGGESTED_AT = 'resolutionSuggestedAt',
  RESOLUTION_EVIDENCE_COMMUNICATION_IDS = 'resolutionEvidenceCommunicationIds',
  DISMISSED_RESOLUTION_EVIDENCE_IDS = 'dismissedResolutionEvidenceIds',
  /** Mirrors apps/api's AGENT_SETUP_MCP_WRITE_CHANGE_KEY
   *  (doboxExecutor/agentSetupAudit.ts) — one row per MCP write an
   *  agent-setup agent executed, `newValue` carrying the raw tool name. */
  AGENT_SETUP_MCP_WRITE = 'agentSetupMcpWrite',
}

export const ACTIVITY_LOG_NULL_SENTINEL = 'null';

// The "looks resolved" fields are the system's flag, shown by the badge; they
// ride along in the diff of a resolve or a dismissal.
export const ACTIVITY_LOG_NOISE_KEYS: ReadonlyArray<ActivityLogChangeKey> = [
  ActivityLogChangeKey.UPDATED_AT,
  ActivityLogChangeKey.VERSION,
  ActivityLogChangeKey.TTL,
  ActivityLogChangeKey.RESOLUTION_SUGGESTED_AT,
  ActivityLogChangeKey.RESOLUTION_EVIDENCE_COMMUNICATION_IDS,
  ActivityLogChangeKey.DISMISSED_RESOLUTION_EVIDENCE_IDS,
];

export const ACTIVITY_LOG_OPTIMISTIC_PREFIX = 'optimistic-';

export const ACTIVITY_LOG_CREATION_STATUSES: ReadonlySet<ActivityLogStatus> =
  new Set([ActivityLogStatus.CREATED, ActivityLogStatus.CREATED_BY_LLM]);
